module.exports = __webpack_public_path__ + "static/media/newspapersTextImg.9eab0326.png";